import React from "react";

function UploadForm({
  label,
  setLabel,
  prompt,
  setPrompt,
  templateName,
  setTemplateName,
  files,
  handleFileChange,
  savePrompt,
  runAnalysis,
  loading,
  progress,
}) {
  return (
    <>
      <div className="mb-3">
        <label className="form-label">Label</label>
        <input
          type="text"
          className="form-control"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Prompt</label>
        <textarea
          className="form-control"
          rows={4}
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
        />
      </div>

      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="New template name"
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
        />
        <button className="btn btn-warning" onClick={savePrompt}>
          Save Template
        </button>
      </div>

      <div className="mb-3">
        <label className="form-label">Upload Files</label>
        <input
          type="file"
          className="form-control"
          multiple
          accept=".pdf,.txt,.csv,.docx"
          onChange={handleFileChange}
        />
        {files.length > 0 && (
          <div className="mt-2 small text-muted">
            Files selected: {files.map((f) => f.name).join(", ")}
          </div>
        )}
      </div>

      <button className="btn btn-primary w-100" onClick={runAnalysis}>
        {loading ? "Processing..." : "Run Full Analysis"}
      </button>

      {loading && (
        <div className="progress mt-3">
          <div className="progress-bar" style={{ width: `${progress}%` }}></div>
        </div>
      )}
    </>
  );
}

export default UploadForm;
